module.exports = __webpack_public_path__ + "static/media/Spinner-0.5s-504px.87058313.svg";